import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Flex,
} from '@frontend/components';

import Logo from 'components/Logo/Logo';
import { PageTitle } from 'components/PageTitle';

import { CURRENT_YEAR } from 'constants/all';

import { selectors } from 'store/app';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const Nav = styled.nav`
  margin-top: 20px;
  text-align: center;
`;

const Main = styled.main`
  padding: 0 10px;
  @media (min-width: 600px) {
    flex-grow: 1;
  }
`;

const Footer = styled.footer`
  flex-grow: 1;
  border-top: 1px solid #eee;
  background: #fdfdfd;
  padding: 1.5rem;
  text-align: center;
  font-size: 0.8125rem;
  line-height: 2;
  @media (min-width: 600px) {
    flex-grow: 0;
  }
`;

const StyledLogo = styled(Logo)`
  max-width: 260px;
`;

const TermsList = styled.ul`
  display: block;
  margin: 0;
  line-height: 2;
  @media (min-width: 600px) {
    margin-bottom: 0.5rem;
    li {
      display: inline-block;
      margin: 0 15px;
    }
  }
`;

const TermsLink = (props) => {
  return (
    <li>
      <a
        className="link link_special"
        target="_blank"
        rel="noopener noreferrer"
        {...props}
      />
    </li>
  );
};

const Copy = styled.small`
  color: #666;
`;

const connector = connect((state) => ({
  didSessionExpire: selectors.getDidUserSessionExpire(state),
  homePage: selectors.getHomePage(state),
}));

const LoginLayout = ({ didSessionExpire, homePage, children }) => {
  return (
    <Wrapper>
      <PageTitle title="Sign in" />
      <Nav>
        {didSessionExpire ? (
          <Flex justify="center" w="100%" mb={1.5}>
            <Alert status="warning" w={53}>
              <AlertIcon />
              <AlertTitle>Your session expired</AlertTitle>
              <AlertDescription>
                Please log in to reauthenticate
              </AlertDescription>
            </Alert>
          </Flex>
        ) : null}
        <h1>
          <Link tabIndex={-1} to={homePage}>
            <StyledLogo />
          </Link>
        </h1>
      </Nav>
      <Main>{children}</Main>
      <Footer>
        <TermsList>
          <TermsLink href="https://help.paperlessparts.com/article/94-general-terms">
            General Terms
          </TermsLink>
          <TermsLink href="https://help.paperlessparts.com/article/95-privacy-policy">
            Privacy Policy
          </TermsLink>
        </TermsList>
        <Copy>&copy; {CURRENT_YEAR}, Paperless Parts, Inc.</Copy>
      </Footer>
    </Wrapper>
  );
};

export default connector(LoginLayout);
